import { EssHeader } from '@/components/ess/EssHeader';
import { FC } from 'react';
import { FiCalendar } from 'react-icons/fi';
import { useParams } from 'react-router-dom';
import { NavPage } from '../../../components/page/Breadcrumbs';
import strings from '../ess.translations';

export const MyAvailabilityHeader: FC = () => {
  const { date } = useParams<{ date: string }>();

  if (!date) {
    throw new Error('Date parameter is required');
  }

  const breadcrumbs: NavPage[] = [
    {
      name: strings.myAvailability.header,
      to: `/ess/my-calendar/${date}/my-availability`
    }
  ];

  return <EssHeader title={strings.myAvailability.header} icon={FiCalendar} breadcrumbs={breadcrumbs} />;
};
